module.exports = __webpack_public_path__ + "static/media/sql.560ce161.svg";